export default function validateDomain(domain, user) {
  if (!domain) {
    console.log('Domain is required');
    return {
      isError: true,
      textError: 'Domain is required',
    };
  }

  // check for invalid characters in url
  if (domain.includes(' ')) {
    console.log('Domain must not contain spaces');
    return {
      isError: true,
      textError: 'Domain must not contain spaces',
    };
  }

  if (user?.isAdmin) {
    return {
      isError: false,
      textError: '',
    }; // no error
  }

  if (!domain.startsWith('https://')) {
    console.log('Domain must start with https://');
    return {
      isError: true,
      textError: 'Domain must start with https://',
    };
  }

  try {
    new URL(domain);

    return {
      isError: false,
      textError: '',
    }; // no error
  } catch (error) {
    console.error(error);
    console.log('Invalid URL');
    return {
      isError: true,
      textError: 'Invalid URL',
    };
  }
}
